module.exports = __webpack_public_path__ + "img/audit.8b57ece5.png";